import { ButtonsGroup } from 'components/shared/ButtonsGroup/ButtonsGroup';
import { useIsInternalUser } from 'hooks/useIsInternalUser';
import { FC, useCallback, useMemo } from 'react';
import { allTradeWays, type TradeWay } from 'state/secondaryMarket/secondaryMarket.model';

export type TradeWayButtonsProps = Readonly<{
  value: Nullable<TradeWay>;
  className?: string;
  onValueChanged?: (value: TradeWay) => void;
  disabledValues: readonly TradeWay[];
  tabIndex?: number;
  e2e: string;
  isDisabled: boolean;
}>;

export const TradeWayButtons: FC<TradeWayButtonsProps> = ({
  className,
  value,
  onValueChanged,
  disabledValues,
  tabIndex,
  e2e,
  isDisabled = false,
}) => {
  const isInternalUser = useIsInternalUser();
  const onSelect = useCallback(
    (items: readonly TradeWay[]) => {
      if (onValueChanged !== undefined) {
        onValueChanged(items[0]);
      }
    },
    [onValueChanged],
  );

  const translationPrefix = useMemo(() => {
    const internalOrExternal = isInternalUser ? 'internalUser' : 'externalUser';
    return `form.tradeWay.${internalOrExternal}`;
  }, [isInternalUser]);

  return (
    <ButtonsGroup
      className={className ?? 'w-100'}
      items={allTradeWays}
      selectedItems={value}
      onSelect={onSelect}
      isRadio
      translationPrefix={translationPrefix}
      isDisabled={isDisabled}
      tabIndex={tabIndex}
      disabledItems={disabledValues}
      isReadonly={onValueChanged === undefined}
      e2e={e2e}
    />
  );
};
